var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3425 0.019043H2.795C1.79486 0.019043 0.985655 0.837338 0.985655 1.83748L0.976562 12.7481C0.976562 13.7482 1.79486 14.5665 2.795 14.5665H17.3425C18.3426 14.5665 19.1609 13.7482 19.1609 12.7481V1.83748C19.1609 0.837338 18.3426 0.019043 17.3425 0.019043ZM17.3425 3.65591L10.0687 8.202L2.795 3.65591V1.83748L10.0687 6.38356L17.3425 1.83748V3.65591Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.63e13167c8c7268ad15e2fcf504eda50.svg";
export { ForwardRef as ReactComponent };